export default __webpack_public_path__ + "static/media/congrants.32bab602.mp3";